<template>
  <!-- Card -->
  <mdb-container>
    <mdb-row class="py-5">
      <div class="container logo-box mb-5">
        <img src="../assets/thitch_logo.png" alt="thitch logo" />
      </div>
       <mdb-col></mdb-col>
      <mdb-col>
          <mdb-card wide>
            <mdb-card-body>
              <form id="loginform">
                <mdb-card-title class="py-3 text-center">Login</mdb-card-title>
                <div class="grey-text">
                  <mdb-input
                    label="Your email"
                    icon="envelope"
                    group
                    type="email"
                    validate
                    error="wrong"
                    success="right"
                    v-model="input.username"
                  />
                  <mdb-input
                    label="Your password"
                    icon="lock"
                    group
                    type="password"
                    validate
                    v-model="input.password"
                  />
                </div>
                <div class="text-center py-4 mt-3">
                  <mdb-btn color="#f9a825 yellow darken-3" icon="sign-in-alt" v-on:click="submit()" type="submit">Login</mdb-btn>
                </div>
              </form>
              <mdb-card-footer class="text-center">
                <mdb-card-title class="py-3 text-center">Not registered?</mdb-card-title>
                <mdb-btn color="#f9a825 yellow darken-3" icon="user" v-on:click="goToRegistration()" rounded>Register here</mdb-btn>
              </mdb-card-footer>
            </mdb-card-body>
          </mdb-card>
      </mdb-col>
      <mdb-col></mdb-col>
    </mdb-row>
  </mdb-container>
  <!-- Card -->
</template>
<script>
import { mdbInput, mdbBtn, mdbCard, mdbCardBody, mdbContainer, mdbRow, mdbCol, mdbCardFooter, mdbCardTitle} from "mdbvue";
//import Vue from 'vue';
export default {
  name: "login",
  components: {
    mdbInput,
    mdbBtn,
    mdbCard,
    mdbCardBody, mdbContainer, mdbRow, mdbCol, mdbCardFooter, mdbCardTitle
  },
  data() {
    return {
      input: {
        username: "",
        password: ""
      }
    };
  },
  beforeCreate: function() {
    if (!this.$session.exists()) {
      this.$router.replace({ name: "login" });
    }
  },
  methods: {
    submit() {
      if (this.input.username != "" && this.input.password != "") {
        event.preventDefault();

        const requestOptions = {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*"
          },
          body: JSON.stringify({
            eMail: this.input.username,
            Password: this.input.password
          })
        };
        fetch(
          //"http://localhost:7071/api/LoginUser",
          "https://thitch.azurewebsites.net/api/LoginUser?code=vP4gFMuices7ppeViKl8Iu1nxPvBoGzurwPlnazYavJa024r5I9Kgg==",
          requestOptions
        )
          //fetch('http://localhost:7071/api/LoginUser', requestOptions)
          .then(async response => {
            var body = await response.json();
            var UserId = body.UserId;
            console.log(body)
            if (response.ok) {
              this.$session.start();
              this.$session.set("UserId", UserId);
              this.$router.replace({ name: "Home" });
            }
          })
          .catch(error => {
            console.log("Error", error);
          });
      } else {
        alert("empty");
      }
    }, 
    goToRegistration: function() {
      this.$router.replace({ name: "registration" });
    }
  }
};
</script>

<style>
body {
  background: #fbc02d !important
}
.card-footer {
  background: none;
}
.logo-box {
  text-align: center;
}
</style>